import { createReducer, on } from '@ngrx/store';
import { AuthState, initialAuthState } from './auth.state';
import { setAuthenticated, setUnauthenticated } from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,
  on(
    setAuthenticated,
    (state): AuthState => ({
      ...state,
      isAuthenticated: true,
    })
  ),

  on(
    setUnauthenticated,
    (state): AuthState => ({
      ...state,
      isAuthenticated: false,
    })
  )
);
